module.exports = __webpack_public_path__ + "img/icn_class.bfa65c2a.svg";